import { Dropdown } from '@vtblife/uikit';
import React, { useState, useRef, useEffect, ReactElement } from 'react';
import classname from '@search/classname/src';
import './ExpandableInfo.css';

export const cn = classname.bind(null, 'ExpandableInfo');

const MAX_HEIGHT = 150;
const MAX_HEIGHT_MOB = 247;

export const ExpandableInfo = ({
    size,
    isMobile = false,
    node
}: {
    size: number;
    isMobile?: boolean;
    node: ReactElement;
}) => {
    const HEIGHT = isMobile ? MAX_HEIGHT_MOB : MAX_HEIGHT;
    const [ showMore, setShowMore ] = useState(false);
    const infoRef = useRef<HTMLDivElement>(null);
    const [ nodeHeight, setNodeHeight ] = useState(HEIGHT);
    const SIZE = isMobile ? 8 : 10;

    const handleShowMore = () => {
        setShowMore(state => ! state);
    };

    useEffect(() => {
        if (infoRef.current) {
            setNodeHeight(showMore ? infoRef?.current.scrollHeight : HEIGHT);
        }
    }, [ showMore, node ]);

    return size > SIZE ? (
        <>
            <div
                ref={infoRef}
                style={{ maxHeight: `${nodeHeight}px` }}
                className={cn('info-container', { isMobile })}
            >
                {node}
            </div>
            {infoRef.current && infoRef.current.scrollHeight > HEIGHT && (
                <Dropdown.SimpleControl onToggle={handleShowMore} opened={showMore}>
                    {showMore ? null : 'Показать полностью'}
                </Dropdown.SimpleControl>)
            }
        </>
    ) : node;
};
